import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteRole as DeleteRoleMutation,
    DeleteRoleVariables as DeleteRoleMutationVariables,
    RoleDeleteInput,
} from 'nutshell-graphql-types';

import DELETE_ROLE from '../mutations/delete-role.graphql';
import GET_ROLES from '../queries/get-roles.graphql';

export function useDeleteRole(): {
    deleteRole: (arg1: RoleDeleteInput) => Promise<any>;
    isDeleting: boolean;
    errorMessage: string | null | undefined;
} {
    const [deleteRole, {loading, error}] = useMutation<
        DeleteRoleMutation,
        DeleteRoleMutationVariables
    >(DELETE_ROLE);

    // @ts-expect-error
    const errorMessage = safelyGetGraphQLErrorMessage(error);

    return {
        deleteRole: (input: RoleDeleteInput) =>
            deleteRole({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const deletedRole =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.roleDelete &&
                        mutationResults.data.roleDelete.role;

                    const cacheResult = proxy.readQuery({
                        query: GET_ROLES,
                    });

                    if (cacheResult && deletedRole) {
                        proxy.writeQuery({
                            query: GET_ROLES,
                            data: {
                                // @ts-expect-error
                                roles: cacheResult.roles.filter(
                                    // @ts-expect-error
                                    (role) => role.id !== deletedRole.id
                                ),
                            },
                        });
                    }
                },
            }),
        isDeleting: loading,
        errorMessage,
    };
}
